module.exports = __webpack_public_path__ + "assets/img/services2.3fcf5b58.svg";